import required from "vuelidate/lib/validators/required";

import FieldSelect from "@components/molecules/m-field-select.vue";

export default {
  component: FieldSelect,
  attrs: {
    label: "VENDEDOR, informe o meio de venda",
    name: "leadSource",
    class: ["leadSource"],
    values: [
      { value: "0800", text: "0800" },
      { value: "abandono", text: "Abandono" },
      { value: "whatsapp", text: "WhatsApp" },
      { value: "MANUAL-0800", text: "Manual - 0800" },
      { value: "MANUAL-CHATBOT", text: "Manual - Chatbot" },
      { value: "MANUAL-CHECKOUT", text: "Manual - Checkout" },
      { value: "PF/PJ-CHATBOT", text: "PF/PJ - Chatbot" },
      { value: "PF/PJ-CHECKOUT", text: "PF/PJ - Checkout" },
      { value: "BLACK-FRIDAY-FIBRA", text: "Black Friday - Fibra" },
      { value: "VIVO-TOTAL-FIBRA-0800", text: "Vivo Total - Fibra 0800" },
      { value: "VIVO-TOTAL-FIBRA-CHATBOT", text: "Vivo Total - Fibra Chatbot" },
      {
        value: "VIVO-TOTAL-FIBRA-CHECKOUT",
        text: "Vivo Total - Fibra Checkout",
      },
    ],
    placeholder: "Selecionar",
    type: "select",
    required: true,
  },
  errorMessages: [
    {
      name: "required",
      message: "Selecione uma opção.",
    },
  ],
  validation: {
    required,
  },
};
